import { render, staticRenderFns } from "./SexAndCompanySummaryChart.vue?vue&type=template&id=6a9f6974&scoped=true"
import script from "./SexAndCompanySummaryChart.vue?vue&type=script&lang=js"
export * from "./SexAndCompanySummaryChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9f6974",
  null
  
)

export default component.exports